import styled from 'styled-components'
import { FileOutlined } from '@ant-design/icons'
import { Text } from '@lmc/ui-kit/src/general'

type FileGalleryItemProps = {
  url: string
  fileName?: string
}

const FilePlaceholderContainer = styled.div`
  width: 58px;
  height: 72px;
  border-radius: 10px;
  background-color: ${({ theme }) => theme.color.neutral.color9};
  border: 1px solid ${({ theme }) => theme.color.neutral.color7};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${({ theme }) => theme.color.neutral.color10};
  }
`

const FileIcon = styled(FileOutlined)`
  font-size: 24px;
  color: ${({ theme }) => theme.color.neutral.color5};
`

const FileNameText = styled(Text)`
  font-size: 10px;
  color: ${({ theme }) => theme.color.neutral.color5};
  text-align: center;
  max-width: 50px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const FileGalleryItem = ({ url, fileName }: FileGalleryItemProps) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    const link = document.createElement('a')
    link.href = url
    link.target = '_blank'
    link.download = fileName || 'file'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  const displayFileName = fileName || url.split('/').pop() || 'file'

  return (
    <FilePlaceholderContainer onClick={handleClick}>
      <FileIcon />
      <FileNameText level={2}>{displayFileName}</FileNameText>
    </FilePlaceholderContainer>
  )
}

